import LinkButton from "components/buttons/LinkButton";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  document.title = "404 | Atrable";

  return (
    <div style={{ minHeight: "100vh", textAlign: "center", marginTop: "90px" }}>
      <h1>Page Not Found</h1>
      <h3>The page you’re looking for can’t be found.</h3>
      <LinkButton
        linkTo="/"
        width="90%"
        maxWidth="300px"
        minWidth="100px"
        backgroundColor="#1877f3"
        color="white"
        zoom
      >
        Go to Home
      </LinkButton>
      <div style={{ height: 60 }} />
      <LinkButton
        linkTo="/new"
        backgroundColor="transparent"
        color="#1877f3"
        zoom
      >
        Make a new post
      </LinkButton>
    </div>
  );
};

export default PageNotFound;
